<template>
	<LayoutForm>
		<h1 slot="header">User Profile Setup</h1>

		<FormStepNav slot="nav" :total-steps="totalSteps" :current-step="currentStep"
		             :completed-step="completedStep" :route-base="routeBase">
		</FormStepNav>

		<UserCreateFormStep1 v-if="currentStep === 1"></UserCreateFormStep1>
		<UserCreateFormStep2 v-if="currentStep === 2"></UserCreateFormStep2>
		<UserCreateFormStep3 v-if="currentStep === 3"></UserCreateFormStep3>
	</LayoutForm>
</template>

<script>
	import LayoutForm from '../Layout/LayoutForm';
	import FormStepNav from '../Form/FormStepNav';
	import MultiStepForm from '../Form/MultiStepForm';
	import UserCreateFormStep1 from './CreateForm/UserCreateFormStep1';
	import UserCreateFormStep2 from './CreateForm/UserCreateFormStep2';
	import UserCreateFormStep3 from './CreateForm/UserCreateFormStep3';

	export default {
		name: 'UserCreateForm',
		mixins: [MultiStepForm],
		components: {
			UserCreateFormStep3,
			UserCreateFormStep2,
			UserCreateFormStep1,
			FormStepNav,
			LayoutForm
		},
		data() {
			return {
				totalSteps: 3,
				routeBase: '/users/create',
			}
		}
	}
</script>
